import { useEffect, useState } from 'react'
import { responseLottoConfig, getRoundLottoConfig } from '@/utils/lotto-type-v2'
import { RootState } from '@/redux/reducers'
import { useSelector } from 'react-redux'

const INIT_LOTTO_CONFIG: responseLottoConfig = {
  betFour: {},
  betOne: {},
  betSix: {},
  betThree: {},
  betTwo: {},
}

export const useLottoConfig = () => {
  const [lottoConfig, setLottoConfig] =
    useState<responseLottoConfig>(INIT_LOTTO_CONFIG)

  // Round data should fetch by src/pagev2/game/hooks/useRoundPage.tsx already
  const round = useSelector((state: RootState) => state.games.round)

  // Update config when round data changes
  useEffect(() => {
    if (round) {
      const config = getRoundLottoConfig(round)
      setLottoConfig(config)
    }
  }, [round])

  return {
    lottoConfig,
  }
}
